import { useState, useCallback } from 'react';

/**
 * 速率限制Hook
 * 使用指数退避算法,防止暴力破解攻击
 */
export const useRateLimit = (maxAttempts: number = 5) => {
  const [attemptCount, setAttemptCount] = useState(0);
  const [lastAttemptTime, setLastAttemptTime] = useState(0);

  const checkRateLimit = useCallback((): boolean => {
    const now = Date.now();
    const cooldownPeriod = Math.min(1000 * Math.pow(2, attemptCount), 60000);
    const timeSinceLastAttempt = now - lastAttemptTime;

    if (timeSinceLastAttempt < cooldownPeriod) {
      return false;
    }

    setLastAttemptTime(now);
    setAttemptCount((prev) => Math.min(prev + 1, maxAttempts));
    return true;
  }, [attemptCount, lastAttemptTime, maxAttempts]);

  const getRemainingTime = useCallback((): number => {
    const now = Date.now();
    const cooldownPeriod = Math.min(1000 * Math.pow(2, attemptCount), 60000);
    const remaining = cooldownPeriod - (now - lastAttemptTime);
    return Math.ceil(Math.max(0, remaining) / 1000);
  }, [attemptCount, lastAttemptTime]);

  const resetAttempts = useCallback(() => {
    setAttemptCount(0);
    setLastAttemptTime(0);
  }, []);

  return { checkRateLimit, getRemainingTime, resetAttempts };
};
